import { chunk, map, size } from 'es-toolkit/compat';

export type SettledBatchResult<ResultType> =
  | {
      status: 'fulfilled';
      value: ResultType;
    }
  | {
      status: 'rejected';
      reason: unknown;
    };

export interface ExecuteInChunksOptions {
  shouldStop?: () => boolean;
  onChunkComplete?: (processedCount: number) => void;
}

export const getBatches = <ItemType>(items: ItemType[] | null | undefined, batchSize: number): ItemType[][] => {
  if (!items || batchSize <= 0) {
    return [];
  }

  return chunk(items, batchSize);
};

export const executeInChunks = async <InputType, ResultType>(
  items: InputType[],
  chunkSize: number,
  callback: (item: InputType) => Promise<ResultType>,
  options?: ExecuteInChunksOptions
) => {
  const chunkedResults: SettledBatchResult<ResultType>[] = [];
  let processedCount = 0;

  for (const itemsChunk of getBatches(items, chunkSize)) {
    if (options?.shouldStop?.()) {
      break;
    }

    const chunkResults = await Promise.allSettled(map(itemsChunk, callback));
    chunkedResults.push(...chunkResults);

    processedCount += size(itemsChunk);
    options?.onChunkComplete?.(processedCount);
  }

  return chunkedResults;
};
